module.exports = __webpack_public_path__ + "media/images/sp/visit_reserve/flow-confirm-7f979eaf7f8f50216a0f97f5a7712f9e.png";